/**
 * Utility functions for unit filtering
 */

/**
 * Get filtered units based on selected part's unit type ID
 */
export const getFilteredUnits = ({
  selectedPartUnitTypeId,
  units,
  text,
  selectedPartId,
}) => {
  if (!selectedPartUnitTypeId) {
    return [];
  }

  if (!selectedPartUnitTypeId || !units || units.length === 0) {
    return units || [];
  }

  if (!selectedPartId) {
    return [];
  }

  let matchedPart = null;
  Object.values(text.partsByType || {}).forEach((typeData) => {
    const part = typeData.parts.find((p) => p?.id === selectedPartId);
    if (part) matchedPart = part;
  });

  if (!matchedPart) {
    return [];
  }

  const defaultUnit = matchedPart.defaultUnit?.trim();
  if (!defaultUnit || defaultUnit === "-") {
    return [];
  }

  const matchingUnitType = units.find(
    (unit) => unit.unit_type_id === selectedPartUnitTypeId
  );

  if (
    matchingUnitType &&
    matchingUnitType.unit_type_for_name &&
    matchingUnitType.unit_type_for_name.length > 0
  ) {
    return [matchingUnitType];
  }

  return units || [];
};
